import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useReadLocalStorage } from 'usehooks-ts';

import * as routes from 'router/routes';
import { LOCAL_STORAGE_KEY, STRING_STORAGE_VALUE_OPTIONS } from 'constants/localStorage';

const MfaRoute = ({ component: Component, ...rest }) => {
  const mfaToken = useReadLocalStorage(LOCAL_STORAGE_KEY.MFA_TOKEN, STRING_STORAGE_VALUE_OPTIONS);

  return (
    <Route
      {...rest}
      render={(props) => (mfaToken ? <Component {...props} /> : <Redirect to={{ pathname: routes.home }} />)}
    />
  );
};

MfaRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.any]).isRequired,
};

export default MfaRoute;
